import React, { useState } from 'react';
import { Modal, Select, Input } from 'antd';
import PropTypes from 'prop-types';

const { TextArea } = Input;
const { Option } = Select;

const DEFAULT_REASONS = {
  loss: [
    { key: 'price', title: 'Price' },
    { key: 'timeline', title: 'Timeline' },
    { key: 'scope', title: 'Scope of Work' },
    { key: 'competitor', title: 'Lost to Competitor' },
    { key: 'client_budget', title: 'Client Budget Constraints' },
    { key: 'no_response', title: 'No Response from Client' },
    { key: 'project_cancelled', title: 'Project Cancelled' },
    { key: 'quality_concerns', title: 'Quality Concerns' },
    { key: 'relationship', title: 'Relationship Issues' },
    { key: 'other', title: 'Other' },
  ],
  revision: [
    { key: 'client_request', title: 'Client Requested Changes' },
    { key: 'pricing_error', title: 'Pricing Error' },
    { key: 'scope_change', title: 'Scope Change' },
    { key: 'measurement_error', title: 'Measurement Error' },
    { key: 'other', title: 'Other' },
  ],
};

const COPY = {
  loss: {
    modalTitle: 'Estimate Loss Reason',
    reasonLabel: 'Loss Reason',
    reasonPlaceholder: 'Select a reason',
    notesLabel: 'Additional Notes',
    notesPlaceholder: 'Enter any additional details about why this estimate was lost...',
  },
  revision: {
    modalTitle: 'Estimate Revision Reason',
    reasonLabel: 'Revision Reason',
    reasonPlaceholder: 'Select a reason',
    notesLabel: 'Additional Notes',
    notesPlaceholder: 'Enter any additional details about why this estimate is being revised...',
  },
};

const EstimateReasonModal = ({ type, visible, onCancel, onSubmit, loading, reasons: reasonsProp }) => {
  const copy = COPY[type] || COPY.loss;

  let reasons = DEFAULT_REASONS[type] || DEFAULT_REASONS.loss;

  if (reasonsProp && Array.isArray(reasonsProp) && reasonsProp.length > 0) {
    // Map the data from settings format (with 'name' field) to our expected format (with 'key' and 'title')
    if (reasonsProp[0].name) {
      reasons = reasonsProp.map((item, index) => ({
        key: item.key || `reason_${index}`,
        title: item.name
      }));
    } else if (reasonsProp[0].key && reasonsProp[0].title) {
      reasons = reasonsProp;
    }
  }

  const [reason, setReason] = useState(null);
  const [notes, setNotes] = useState('');

  const handleSubmit = () => {
    onSubmit({ reason, notes });
    setReason(null);
    setNotes('');
  };

  const handleCancel = () => {
    setReason(null);
    setNotes('');
    onCancel();
  };

  return (
    <Modal
      title={copy.modalTitle}
      visible={visible}
      onOk={handleSubmit}
      onCancel={handleCancel}
      okText="Submit"
      cancelText="Cancel"
      confirmLoading={loading}
      okButtonProps={{ disabled: !reason }}
    >
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>
          {copy.reasonLabel} <span style={{ color: 'red' }}>*</span>
        </label>
        <Select
          style={{ width: '100%' }}
          placeholder={copy.reasonPlaceholder}
          value={reason}
          onChange={setReason}
        >
          {reasons.map(reasonOption => (
            <Option key={reasonOption.key} value={reasonOption.title}>
              {reasonOption.title}
            </Option>
          ))}
        </Select>
      </div>

      <div>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>
          {copy.notesLabel}
        </label>
        <TextArea
          rows={4}
          placeholder={copy.notesPlaceholder}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
      </div>
    </Modal>
  );
};

EstimateReasonModal.propTypes = {
  type: PropTypes.oneOf(['loss', 'revision']).isRequired,
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  reasons: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    name: PropTypes.string,
  })),
};

EstimateReasonModal.defaultProps = {
  loading: false,
  reasons: null,
};

export default EstimateReasonModal;
